import { DownloadFileContentModal } from "../download-file-content/download-file-content-modal.component";
import { Component } from "@angular/core";
import { ReportsService, MedicalBenefitOrderOptions, ApiRequestDtoMedicalBenefitOrderOptions } from "../../api";
import { BillingHistoryOptions } from "../../api/model/billingHistoryOptions";
import { FacilitiesService } from "../../core";
import SortOrderEnum = BillingHistoryOptions.SortOrderEnum;
import { DateConversion } from "../../shared/date/date-range";
import { LoadingError, ErrorObjectTypeEnum } from "../../core/error-catching.service";
import { catchError } from "rxjs/operators";

export const RxStatusOptions: any [] = [
    {
        Name: "New Rx Only",
        Value: "A"
    },
    {
        Name: "Refill",
        Value: "B"
    }, 
    {
        Name: "Both",
        Value: "C"
    }
];




@Component({
    selector: 'medical-benefit-order',
    templateUrl: 'medical-benefit-order.html',
    styleUrls: ['medical-benefit-order.scss']
})
export class MedicalBenefitOrderModal extends DownloadFileContentModal{

    reportName: string = "Medical Benefit Orders";
    title: string = "Download Medical Benefit Orders";
    searchText: string;
    rxStatusList: any[] = [];
    selectedRxStatus: any;
    showDateRangeSelector: boolean = true;

    isLoadingInvoiceGroups: boolean=false;
    hideSpinner:boolean = true;

    sortOrderEnums: SortOrderEnum[];
    selectedSortOrder: SortOrderEnum = SortOrderEnum.ResidentName;


        
    constructor( private reportService: ReportsService, private facilityService: FacilitiesService){
        super();
        this.maxDate = this.endDate;
        
        
    }


    show() {
        this.hideSpinner = true;
        this.isLoadingInvoiceGroups = true;
        this.rxStatusList = [];

        // Explicit list to ensure order
        this.sortOrderEnums = [SortOrderEnum.ResidentName, SortOrderEnum.InvoiceGroup]

        RxStatusOptions.forEach(element => {
            this.rxStatusList.push(element) 
        this.selectedRxStatus = this.rxStatusList[0]; //Default to New Rx Only
      });
        
        super.show();       
    }

    selectRxStatus(RxStatus: any) {
        setTimeout(() => {
            this.selectedRxStatus = RxStatus;
        });
    }

    canGenerateReport(): boolean {
        if (!this.isValidDateRange){
            return false;
        }
        else if (!this.selectedRxStatus) {
            return false;
        }
        else {
            return this.hideSpinner;
        }
    }

    generateContent() {
        this.hideSpinner = false;
             
        let medicalBenefitsOptions : MedicalBenefitOrderOptions = {
            StartDate: DateConversion.localDateToStartOfDayJsUTC(this.dateRange.startDate),
            EndDate: DateConversion.localDateToStartOfDayJsUTC(this.dateRange.endDate),
            RxStatus: this.selectedRxStatus.Value
        };
        const requestParams: ApiRequestDtoMedicalBenefitOrderOptions = { 
            OrgList: this.facilityService.selectedAsOrgList,
            _RequestOptions: medicalBenefitsOptions
        };
        this.reportService.reportsGetGeneratedMedicalBenefitOrderReport(requestParams)
            .pipe(catchError((error) => {
                this.hideSpinner = true;
                throw new LoadingError(this.reportName, ErrorObjectTypeEnum.Report);
            }))
            .subscribe((result: Blob) => {
                this.downloadFile(result, "Medical Benefit Orders.xls");
                this.closeModal();
            });
    }
}